export var TileOrientation;
(function (TileOrientation) {
    TileOrientation["HORIZONTAL"] = "horizontal";
    TileOrientation["VERTICAL"] = "vertical";
})(TileOrientation || (TileOrientation = {}));
//# sourceMappingURL=TileOrientation.js.map